
    import Client from 'client';
    import Page from '/var/lib/jenkins/workspace/wxhebi-nodejs-website/app/web/page/news-pc/topic.vue';
    export default Client.render({ ...Page });
  


// WEBPACK FOOTER //
// ./app/web/page/news-pc/topic.vue